import { SAVE_INSTALLATION_ORDERS, SAVE_INSTALLATION_ORDERS_ALL } from '../actions/worklist';

const defaultState = {
  installationOrders: [],
  installationOrdersAll: [],
};

export default (state = defaultState, action) => {
  switch (action.type) {
    case SAVE_INSTALLATION_ORDERS:
      if (action.installationOrders) {
        return {
          ...state,
          installationOrders: action.installationOrders,
        };
      }
      break;
    case SAVE_INSTALLATION_ORDERS_ALL:
      if (action.installationOrdersAll) {
        return {
          ...state,
          installationOrdersAll: action.installationOrdersAll,
        };
      }
      break;
    default:
  }
  return state;
};
